import React, { useEffect, useState } from "react";
import { Container, SoundWaveBars, Bar } from "./AudioWaveform.Styled";
import tinycolor from "tinycolor2";

const generateGradientColors = (
  startColor: string,
  endColor: string,
  steps: number
) => {
  const start = tinycolor(startColor).toRgb();
  const end = tinycolor(endColor).toRgb();
  const colors = [];

  for (let i = 0; i < steps; i++) {
    const ratio = i / (steps - 1);
    const r = Math.round(start.r + ratio * (end.r - start.r));
    const g = Math.round(start.g + ratio * (end.g - start.g));
    const b = Math.round(start.b + ratio * (end.b - start.b));
    colors.push(tinycolor({ r, g, b }).toHexString());
  }

  return colors;
};

const gradientColors = generateGradientColors("#FF0000", "#0000FF", 35);

const AudioWaveform: React.FC = () => {
  const [durations, setDurations] = useState<string[]>([]);

  useEffect(() => {
    const generateDurations = () => {
      const newDurations = Array.from(
        { length: 35 },
        (_, i) => `${(0.25 + ((i * 0.015) % 0.5)).toFixed(2)}s`
      );
      setDurations(newDurations);
    };

    generateDurations();
  }, []);

  return (
    <Container>
      <SoundWaveBars>
        {durations.map((duration, index) => (
          <Bar
            key={index}
            animationDuration={duration}
            color={gradientColors[index % gradientColors.length]}
          />
        ))}
      </SoundWaveBars>
    </Container>
  );
};

export default AudioWaveform;
